import TextWithLineBreaks from '@/components/common/LineBreaksBox';
import { AppLog } from '@/types/analytics';
import { ContentCopy } from '@mui/icons-material';
import { Dialog, DialogContent, DialogContentText, IconButton, Stack } from '@mui/material';
import { FC } from 'react';

type AppLogInfoProps = {
  log: AppLog;
  copySuccessful: () => void;
  onClose: () => void;
};

const AppLogInfo: FC<AppLogInfoProps> = ({ log, copySuccessful, onClose }) => {
  const copyValue = (value: string) => {
    navigator.clipboard.writeText(value);
    copySuccessful();
  };

  return (
    <Dialog open={Boolean(log)} onClose={onClose}>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Stack direction='column' border={'1px solid'} borderRadius={1} px={1}>
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <DialogContentText>Message</DialogContentText>
            <IconButton sx={{ ml: 1 }} onClick={(e) => copyValue(log.message)} color='inherit' size='small'>
              <ContentCopy />
            </IconButton>
          </Stack>
          <TextWithLineBreaks>{log.message}</TextWithLineBreaks>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AppLogInfo;
